export default function Loader() {
  return <span className="loader" role="status" aria-label="Loading" />
}
